import paper from 'paper';
import { Group, Point, Path, PointText, Color } from 'paper';
import PathStyle from './PathStyle';
import store from '../store';

export default {
    repaint(composition) {
        paper.project.layers.view.removeChildren();

        solid(composition.solidItems, composition.pieces);
        offsets(composition.offsets);
        points(composition.points);
        if (store.getters.mode == 'blueprint') {
            originalPaths(composition.originalPaths);
            autocorrects(composition.autocorrects);
            warnings(composition.warnings);
        }
        this.afterZoom();
    },

    afterZoom() {
        if (store.getters.mode != 'blueprint' && store.getters.shapes.length > 1) {
            this.displayOrigin();
            this.displayPosition();
        }

        if (store.getters.mode == 'blueprint') {
            this.showCrossings();
            this.showOpenPaths();
            this.showAutocorrects();
            this.showCrossingsFromApi();
            if (store.getters.displayErrors == 'removed') {
                this.showRemoved();
            }
            if (store.getters.tool == "itemsize") {
                this.displayItemSize();
            }
        }
    },

    showCrossings() {
        paper.project.layers.view.getItems({ name: 'crossingCircle' }).forEach(i => i.remove());
        if (!store.getters.cleaningReport || !store.getters.cleaningReport.crossings || !store.getters.cleaningReport.crossings.intersections) return;
        store.getters.cleaningReport.crossings.intersections.forEach(crossing => {
            let circle = new Path.Circle({
                name: 'crossingCircle',
                center: crossing,
                strokeWidth: 2,
                strokeScaling: false,
                radius: 6 / store.getters.zoom,
                strokeColor: '#EF3340'
            })
            paper.project.layers.view.addChild(circle);
        });
    },

    showOpenPaths() {
        paper.project.layers.view.getItems({ name: 'openPathCopy' }).forEach(i => i.remove());
        if (!store.getters.cleaningReport || !store.getters.cleaningReport.openPaths || !store.getters.cleaningReport.openPaths.items) return;
        store.getters.cleaningReport.openPaths.items.forEach(item => {
            let path = paper.project.getItem({ id: item });

            let circle = new Path.Circle({
                name: 'crossingCircle',
                center: path.firstSegment.point,
                strokeWidth: 2,
                strokeScaling: false,
                radius: 6 / store.getters.zoom,
                strokeColor: '#F5D600'
            })
            paper.project.layers.view.addChild(circle);

            circle = new Path.Circle({
                name: 'crossingCircle',
                center: path.lastSegment.point,
                strokeWidth: 2,
                strokeScaling: false,
                radius: 6 / store.getters.zoom,
                strokeColor: '#F5D600'
            })
            paper.project.layers.view.addChild(circle);
        });
    },

    showCrossingsFromApi() {
        if(store.getters.crossingPoints.length > 0){
            paper.project.layers.view.getItems({ name: 'crossing' }).forEach(i => i.remove());
            store.getters.crossingPoints.forEach(point => {
                let circle = new Path.Circle({
                    center: point.point,
                    name: 'crossing',
                    strokeWidth: 1,
                    radius: 6 / store.getters.zoom,
                    strokeColor: "red",
                    strokeScaling: false
                })
                paper.project.layers.view.addChild(circle);
            })
        }
    },

    showAutocorrects() {
        paper.project.layers.view.getItems({ name: 'autocorrect' })
            .forEach(i => i.strokeWidth = 2);
    },
    hideAutocorrects() {
        paper.project.layers.view.getItems({ name: 'autocorrect' })
            .forEach(i => i.strokeWidth = 0);
    },
    showRemoved() {
        paper.project.layers.view.getItems({ name: 'removed' })
            .forEach(i => i.strokeWidth = 2);
    },
    hideRemoved() {
        paper.project.layers.view.getItems({ name: 'removed' })
            .forEach(i => i.strokeWidth = 0);
    },
    removePosition() {
        let existing = paper.project.layers.view.getItems({ name: 'position' });
        existing.forEach(e => e.remove());
    },

    hideItemSize() {
        let existing = paper.project.layers.view.getItems({ name: 'itemSize' });
        existing.forEach(e => e.remove());
    },

    showImport() {
        PathStyle.importItem(paper.project.layers.import);
    },

    hideImport() {
        PathStyle.hideItem(paper.project.layers.import);
    },

    showBlueprint() {
        PathStyle.blueprintItem(paper.project.layers.blueprint);
    },

    hideBlueprint() {
        PathStyle.hideItem(paper.project.layers.blueprint);
    },

    displayItemSize() {
        this.hideItemSize();
        let itemId = store.getters.sizeItemId;
        if (!itemId) return;

        let item = paper.project.layers.blueprint.getItem({ id: store.getters.sizeItemId });
        if (!item) return;

        this.displayBounds(item.bounds);
    },

    removeOrigin() {
        let existing = paper.project.layers.view.getItems({ name: 'origin' });
        existing.forEach(e => e.remove());
    },

    displayOrigin() {
        this.removeOrigin();
        let o = store.getters.origin,
            zoom = store.getters.zoom,
            size = 10 / zoom,
            length = 50 / zoom,
            fontSize = 16 / zoom,
            xAxis = this.singleArrow(o, o.add(new Point(length, 0)), size),
            yAxis = this.singleArrow(o, o.add(new Point(0, -length)), size),
            oGroup = new Group({ name: 'origin' });

        PathStyle.xAxis(xAxis);
        PathStyle.yAxis(yAxis);

        oGroup.addChildren([
            xAxis,
            yAxis,
            this.label(
                '0',
                new Point(
                    o.x - size,
                    o.y + size + fontSize / 2
                ),
                'center',
                fontSize
            ),
        ]);

        oGroup.addTo(paper.project.layers.view);
    },

    displayBounds(bounds) {
        if (!bounds || bounds.area <= 0 ) return;


        let zoom = store.getters.zoom,
            padding = 16 / zoom,
            size = 10 / zoom,
            fontSize = padding,
            horizy = bounds.bottom + padding,
            vertx = bounds.left - padding,
            pgroup = new Group({ name: 'itemSize' }),
            cotes = new Group(),
            suivi = new Group(),
            labels = new Group();

        cotes.addChildren([
            this.doubleArrow(
                new Point(bounds.left, horizy),
                new Point(bounds.right, horizy),
                size
            ),
            this.doubleArrow(
                new Point(vertx, bounds.top),
                new Point(vertx, bounds.bottom),
                size
            )
        ]);

        PathStyle.cotesLine(cotes);
        pgroup.addChild(cotes);


        suivi.addChildren([
            new Path([
                new Point(bounds.right, bounds.bottom),
                new Point(vertx, bounds.bottom)
            ]),
            new Path([
                new Point(bounds.left, bounds.top),
                new Point(bounds.left, horizy)
            ]),
            new Path([
                new Point(bounds.right, bounds.top),
                new Point(bounds.right, horizy)
            ]),
            new Path([
                new Point(bounds.right, bounds.top),
                new Point(vertx, bounds.top)
            ])
        ]);

        PathStyle.suiviLine(suivi);
        pgroup.addChild(suivi);

        let widthLabel = Math.round(bounds.width * 100) / 100;
        let heightLabel = Math.round(bounds.height * 100) / 100;

        labels.addChildren([
            this.label(
                `X : ${widthLabel} mm`,
                new Point(
                    (bounds.left + bounds.right) / 2,
                    horizy + padding + fontSize / 2
                ),
                'center',
                fontSize
            ),
            this.label(
                `Y : ${heightLabel} mm`,
                new Point(
                    vertx - padding / 2,
                    (bounds.top + bounds.bottom) / 2 + fontSize / 4
                ),
                'right',
                fontSize
            )
        ]);
        pgroup.addChild(labels);

        pgroup.addTo(paper.project.layers.view);
        return pgroup;
    },

    displayPosition(position) {
        if (store.getters.shapes.length <= 1) return;
        this.removePosition();
        let o = store.getters.origin;

        if (typeof position === 'undefined') {
            position = getSelectedPosition();
        }

        if (!o || !position || o.equals(position)) return;

        let x = position.x - o.x,
            y = o.y - position.y,
            zoom = store.getters.zoom,
            padding = 16 / zoom,
            size = 10 / zoom,
            fontSize = padding,
            horizy = Math.max(o.y, position.y) + padding,
            vertx = Math.min(o.x, position.x) - padding,
            pgroup = new Group({ name: 'position' }),
            cotes = new Group(),
            suivi = new Group(),
            labels = new Group();

        cotes.addChildren([
            this.doubleArrow(
                new Point(o.x, horizy),
                new Point(position.x, horizy),
                size
            ),
            this.doubleArrow(
                new Point(vertx, o.y),
                new Point(vertx, position.y),
                size
            )
        ]);

        PathStyle.cotesLine(cotes);
        pgroup.addChild(cotes);


        suivi.addChildren([
            new Path([
                new Point(o.x, o.y),
                new Point(vertx, o.y)
            ]),
            new Path([
                new Point(o.x, o.y),
                new Point(o.x, horizy)
            ]),
            new Path([
                new Point(position.x, position.y),
                new Point(position.x, horizy)
            ]),
            new Path([
                new Point(position.x, position.y),
                new Point(vertx, position.y)
            ])
        ]);

        PathStyle.suiviLine(suivi);
        pgroup.addChild(suivi);

        labels.addChildren([
            this.label(
                'X : ' + Math.round(x) + ' mm',
                new Point(
                    (position.x + o.x) / 2,
                    horizy + padding + fontSize / 2
                ),
                'center',
                fontSize
            ),
            this.label(
                'Y : ' + Math.round(y) + ' mm',
                new Point(
                    vertx - padding / 2,
                    (position.y + o.y) / 2 + fontSize / 4
                ),
                'right',
                fontSize
            )
        ]);
        pgroup.addChild(labels);

        pgroup.addTo(paper.project.layers.view);
    },

    singleArrow(p1, p2, size) {
        let vector = p2.subtract(p1);
        let arrowVector = vector.normalize(size);

        return new Group([
            new Path([p1, p2]),
            new Path([
                p2.add(arrowVector.rotate(135)),
                p2,
                p2.add(arrowVector.rotate(-135))
            ])
        ]);
    },

    doubleArrow(p1, p2, size) {

        let vector = p2.subtract(p1);
        let arrowVector = vector.normalize(size);

        if (vector.length > 4 * size) {
            return new Group([
                new Path([p1, p2]),
                new Path([
                    p2.add(arrowVector.rotate(135)),
                    p2,
                    p2.add(arrowVector.rotate(-135))
                ]),
                new Path([
                    p1.add(arrowVector.rotate(45)),
                    p1,
                    p1.add(arrowVector.rotate(-45))
                ])
            ]);
        }
        else {
            return new Group([
                new Path([p1, p2]),
                new Path([
                    p2.add(arrowVector.rotate(45)),
                    p2,
                    p2.add(arrowVector.rotate(-45))
                ]),
                new Path([
                    p1.add(arrowVector.rotate(135)),
                    p1,
                    p1.add(arrowVector.rotate(-135))
                ])
            ]);
        }
    },

    label(content, point, justification, fontSize) {
        let text = new PointText(point);
        text.style = {
            fontFamily: 'Open Sans',
            fontSize,
            fillColor: '#59ABFF',
            justification
        };
        text.content = content;

        let background = new Path.Rectangle(text.bounds);
        background.fillColor = new Color(0.91, 0.97, 0.97, 0.85);
        background.strokeWidth = 0;
        text.insertAbove(background);

        return new Group([
            background,
            text
        ]);
    }
}

function getSelectedPosition() {
    if (store.getters.selectedShapeIds.length < 1) return null;

    let selectedShapesIds = store.getters.selectedShapeIds,
        selectedShapes = selectedShapesIds.map(id => store.getters.shapes.find(s => s.id == id));
    if (selectedShapes.length == 0) return null;
    return selectedShapes[0].referencePoint();
}

function solid(items, pieces) {
    if (items) {
        items.forEach(item => {
            let imported = paper.project.layers.view.importJSON(item);
            let name = imported.name.replace('_solid', '');
            let piece = pieces.filter(p => p.name == name);
            if (piece.length > 0 && piece[0].validSize) {
                if (store.getters.cuttingOptions.dxfFormatting == 1) {
                    PathStyle.solidMetal(imported);
                } else if (store.getters.cuttingOptions.dxfFormatting == 2) {
                    PathStyle.solidWood(imported);
                } else {
                    PathStyle.solid(imported);
                }
            } else {
                PathStyle.invalidSize(imported);
            }
        });
    }
}

function originalPaths(originalPaths) {
    if (originalPaths == null) return;
    originalPaths
        .forEach(path => {
            PathStyle.originalPath(paper.project.layers.view.importJSON(path));
        })
}

function autocorrects(corrections) {
    if (corrections == null) return;
    corrections.forEach(correction => {
        let temp;
        if(correction.level == 'warning' || correction.level == 'alert'){
            temp = paper.project.layers.temp.importJSON(correction.before);
            circleAround(temp, 'autocorrect', 'red');
            temp.remove();
        }
    });
}

function warnings(warnings) {
    if (warnings == null) return;
    warnings.forEach(warning => {
        if (warning.code == 'removed') {
            let temp = paper.project.layers.temp.importJSON(warning.item);
            circleAround(temp, 'removed');
            temp.remove();
        }
        if (warning.code == 'notClosed') console.error("Deprecated warning : notClosed");
        if (warning.code == 'crossing') console.error("Deprecated warning : crossing");
    })
}

function circleAround(item, name, color= 'red') {
    let bounds = item.bounds;
    let radius = bounds.width > bounds.height ? bounds.width / 2 : bounds.height / 2;
    radius *= 1.2;

    let circle = new Path.Circle({
        name,
        center: bounds.center,
        strokeWidth: 2,
        strokeScaling: false,
        radius: radius,
        strokeColor: color
    })
    paper.project.layers.view.addChild(circle);
}

function offsets(offsets) {
    if (offsets == null) return;
    offsets.forEach(offset => {
        PathStyle.offset(paper.project.layers.view.importJSON(offset));
    })
}

function points(points) {
    if (points == null) return;
    points.forEach(point => {
        let circle = new Path.Circle({
            center: point.point,
            strokeWidth: 1,
            radius: 0.1,
            strokeColor: point.color,
            strokeScaling: false
        })
        paper.project.layers.view.addChild(circle);
    })
}
